import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import FilmsCategory from "@/pages/category/films/page";
import StarsCategory from "@/pages/category/stars/page";
import TopicsCategory from "@/pages/category/topics/page";
import FilmDetail from "@/pages/detail/film/page";
import StarDetail from "@/pages/detail/star/page";
import TopicDetail from "@/pages/detail/topic/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/films", element: <FilmsCategory /> },
      { path: "category/stars", element: <StarsCategory /> },
      { path: "category/topics", element: <TopicsCategory /> },
      { path: "detail/film/:id", element: <FilmDetail /> },
      { path: "detail/star/:id", element: <StarDetail /> },
      { path: "detail/topic/:id", element: <TopicDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;